/* eslint-disable react-hooks/exhaustive-deps */

import { useAuth } from "context/AuthContext";
import { Outlet } from "react-router";
import { UserInfo } from "components/user-info";

import "./styles.scss";
import { NavLink } from "react-router-dom";
import { NavMenu } from "components/navmenu";
import { Helmet } from "react-helmet-async";
import { useEffect, useState, useMemo } from "react";
import { useModal } from "context/ModalContext";
import { RegulamentoFooter } from "components/regulamento-footer";
import { 
  getTransparencia,
  getDesafios,
  getDesafiosConquistados, 
  getPontosDistribuidos, 
  getTotaItensCadastradosLoja, 
  getPremiosDistribuidos, 
  getRelelatorioAnaliticoResgates 
} from "services/transparencia.service";
import { set } from "date-fns";
import moment from "moment";
import "moment/locale/pt-br";
import { jsPDF } from "jspdf";

moment.locale("pt-br");

export function Transparencia() {
  const [loading, setLoading] = useState<boolean>(false);
  const [transparencia, setTransparencia] = useState<any>();
  const [desafios, setDesafios] = useState<any>();
  const [desafiosConquistados, setDesafiosConquistados] = useState<any>();
  const [pontosDistribuidos, setPontosDistribuidos] = useState<any>();
  const [totalItensLoja, setTotalItensLoja] = useState<any>();
  const [premiosDistribuidos, setPremiosDistribuidos] = useState<any>();
  const [relatorioAnalitico, setRelatorioAnalitico] = useState<any>();
  const [nameFilter, setNameFilter] = useState<string>("");
  const [activeTab, setActiveTab] = useState<string>("numeros");

  const filteredRelatorio = useMemo(() => {
    const rawFilter = (nameFilter || "").trim().toLowerCase();
    if (!rawFilter) return (relatorioAnalitico || []);
    return (relatorioAnalitico || []).filter((item: any) => {
      const itemName = (item.item_name || "").toString().toLowerCase();
      return itemName.includes(rawFilter);
    });
  }, [relatorioAnalitico, nameFilter]);

  const { user } = useAuth();
  const { showModal } = useModal();

  useEffect(() => {
    if (user) {
      setLoading(true);
      getTransparencia().then(function (data) {
        setTransparencia(data[0]);
        setLoading(false);
      }).finally(() => {
        setLoading(false);
      });
    }
  }, [user]);

  useEffect(() => {
    if (user && transparencia) {
      setLoading(true);
      getDesafios(transparencia.startPeriod, transparencia.endPeriod).then(function (data) {
        setDesafios(data[0]);        
      });
      getDesafiosConquistados(transparencia.startPeriod, transparencia.endPeriod).then(function (data) {
        setDesafiosConquistados(data[0]);        
      });
      getPontosDistribuidos(transparencia.startPeriod, transparencia.endPeriod).then(function (data) {
        setPontosDistribuidos(data[0]);        
      });
      getTotaItensCadastradosLoja(transparencia.startPeriod, transparencia.endPeriod).then(function (data) {
        setTotalItensLoja(data);        
      });
      getPremiosDistribuidos(transparencia.startPeriod, transparencia.endPeriod).then(function (data) {
        setPremiosDistribuidos(data);
      }).finally(() => {
        setLoading(false);
      });
    }
  }, [user, transparencia]);

  function showTab(tab: string){
    setActiveTab(tab);
    
    if(tab === "relatorio" && !relatorioAnalitico){
      setLoading(true);
      getRelelatorioAnaliticoResgates(transparencia.startPeriod, transparencia.endPeriod).then(function (data) {
        setRelatorioAnalitico(data);
      }).finally(() => {
        setLoading(false);
      });
    }
  }

  function escapeHtml(unsafe: any) {
    if (unsafe === null || unsafe === undefined) return "";
    return String(unsafe)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function exportTableAsPdf() {
    try {
      const doc = new jsPDF("l", "mm", "a4");
       const pageWidth = doc.internal.pageSize.getWidth();
       const pageHeight = doc.internal.pageSize.getHeight();

      doc.setFontSize(16);
       doc.setTextColor(0, 51, 160);
      doc.setFont("helvetica", "bold");
       doc.text("Relatório Analítico de Resgates", pageWidth / 2, 15, { align: "center" });

      doc.setFontSize(10);
       doc.setTextColor(0, 0, 0);
      doc.setFont("helvetica", "normal");
       doc.text(`Gerado em ${moment().format("DD/MM/YYYY [às] HH:mm")}`, pageWidth / 2, 22, { align: "center" });

       const headers = ["#", "ITEM", "CPF", "DATA DO RESGATE", "MILISSEGUNDOS"];
       const colWidths = [12, 50, 40, 50, 40];
      const tableData = (filteredRelatorio || []).map((item: any, index: number) => [
        String(index + 1),
        item.item_name || "",
        item.cpf || "",
        moment(item.time).format("DD/MM/YYYY HH:mm") || "",
        item.milissegundos || ""
      ]);

       let y = 30;
       const headerHeight = 8;
       const rowHeight = 7;
       const maxRowsPerPage = 30;

       const drawHeader = () => {
         doc.setFillColor(0, 174, 239);
         doc.setTextColor(255, 255, 255);
         doc.setFont("helvetica", "bold");
         doc.setFontSize(10);

         let x = 10;
         headers.forEach((header: string) => {
           doc.rect(x, y - headerHeight + 1, colWidths[headers.indexOf(header)], headerHeight, "F");
           doc.text(header, x + 2, y - 1, { maxWidth: colWidths[headers.indexOf(header)] - 2 });
           x += colWidths[headers.indexOf(header)];
         });

         doc.setTextColor(0, 0, 0);
         doc.setFont("helvetica", "normal");
         doc.setFontSize(9);
         y += headerHeight;
       };

       drawHeader();

       let rowIndex = 0;
       tableData.forEach((row: any[], rowIdx: number) => {
         if (rowIndex >= maxRowsPerPage) {
           doc.addPage();
           y = 20;
           drawHeader();
           rowIndex = 0;
         }

         let x = 10;
         if (rowIdx % 2 === 0) {
           doc.setFillColor(255, 255, 255);
         } else {
           doc.setFillColor(240, 251, 255);
         }
         doc.rect(x - 1, y, pageWidth - 12, rowHeight, "F");

         doc.setTextColor(0, 0, 0);
         doc.setFont("helvetica", "normal");
         doc.setFontSize(8);

         row.forEach((cell: any, i: number) => {
           doc.text(String(cell), x + 2, y + 5, { maxWidth: colWidths[i] - 4 });
           x += colWidths[i];
         });

         y += rowHeight;
         rowIndex++;
       });

       const totalPages = doc.internal.pages.length - 1;
       for (let i = 1; i <= totalPages; i++) {
         doc.setPage(i);
         doc.setTextColor(128, 128, 128);
         doc.setFont("helvetica", "normal");
         doc.setFontSize(9);
         doc.text(`Página ${i}`, pageWidth / 2, pageHeight - 10, { align: "center" });
       }

      doc.save(`relatorio-resgates-${moment().format("YYYY-MM-DD_HHmmss")}.pdf`);
    } catch (err) {
      console.error("Erro ao gerar PDF:", err);
      alert("Erro ao gerar o PDF. Tente novamente.");
    }
  }

  if (!user) return null;

  return (
    <>
      <Helmet>
        <title>CONTA COMIGO BRB</title>
      </Helmet>
      <div id="home-wrapper" className="min-h-screen">
        <div className="z-10 relative flex flex-col items-center space-y-0 md:space-y-10 md:pt-10">
          <NavMenu />

          <div className="w-full flex justify-center md:p-0">
            <UserInfo />
          </div>
          
          <div className="bg-[#F2F2F2] w-screen text-black md:-mx-10 bgShadow p-5">
            <div className="w-full md:w-[1200px] mx-auto" id="transparencia">
              <h2>
                <strong>Transparência</strong>
              </h2>
              {loading && <h3>Carregando...</h3>}

              {!loading && pontosDistribuidos && totalItensLoja && premiosDistribuidos && (
                
                  <div>
                    {activeTab === "numeros" && (
                      <div>
                        <img className="mb-[50px]" src={transparencia.image.original.url} alt="" />
                        <div className="grid grid-cols-3 gap-y-8 gap-x-16 text-center md:text-left justify-items-center md:justify-items-start">
                          <div>
                            <p className="text-4xl md:text-5xl font-extrabold text-[#0033A0]">{pontosDistribuidos.total.toLocaleString('pt-BR')}</p>
                            <p className="text-[1.7em] font-semibold text-[#00AEEF]">Estrelas distribuídas</p>
                          </div>

                          {totalItensLoja.map((item: any, index: number) => (
                            <div key={index}>
                              <p className="text-4xl md:text-5xl font-extrabold text-[#0033A0]">{item.total.toLocaleString('pt-BR')}</p>
                              <p className="text-[1.7em] font-semibold text-[#00AEEF]">{item._id}</p>
                            </div>
                          ))}

                          {premiosDistribuidos.map((item: any, index: number) => (
                            <div key={index}>
                              <p className="text-4xl md:text-5xl font-extrabold text-[#0033A0]">{item.total.toLocaleString('pt-BR')}</p>
                              <p className="text-[1.7em] font-semibold text-[#00AEEF]">{item.tipo}</p>
                            </div>
                          ))}
                        </div>
                        <button className="block bg-[#88e1f2] text-white border border-white rounded-lg px-8 py-2.5 my-5 mx-auto my-[50px] font-bold text-[1.1em]" onClick={()=>showTab("relatorio")}>
                          Relatório Analítico de Resgates <i className="gg-software-download"></i>
                        </button>
                    </div>
                  )}

                  {activeTab === "relatorio" && (
                      <div>
                        {loading ? (<h3>Carregando...</h3>) : (
                          <div>
                            <div className="flex items-center gap-3">
                              <button className="block bg-[#88e1f2] text-white border border-white rounded-lg px-8 py-2.5 my-5 my-[50px] font-bold text-[1.1em]" onClick={()=>showTab("numeros")}>
                                Voltar <i className="gg-software-download"></i>
                              </button>
                              <button className="block bg-[#0066cc] text-white border border-white rounded-lg px-4 py-2 my-5 my-[50px] font-bold text-[0.95em]" onClick={exportTableAsPdf}>
                                Baixar PDF
                              </button>
                            </div>
                            
                            <div className="mb-4 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                              <div className="flex items-center gap-2">
                                <label className="font-semibold">Filtrar por ITEM:</label>
                                <input
                                  type="text"
                                  className="border rounded px-3 py-1 text-sm"
                                  placeholder="Digite o nome do item"
                                  value={nameFilter}
                                  onChange={(e) => setNameFilter(e.target.value)}
                                />
                              </div>
                              <div className="text-sm text-gray-600">Total: {filteredRelatorio.length}</div>
                            </div>

                            <table className="min-w-full border border-gray-200 rounded-lg overflow-hidden text-sm text-gray-700 shadow-sm">
                              <thead className="bg-[#00AEEF] text-white">
                                <tr>
                                  <th></th>
                                  <th className="px-4 py-3 text-left font-semibold">ITEM</th>
                                  <th className="px-4 py-3 text-left font-semibold">CPF</th>
                                  <th className="px-4 py-3 text-left font-semibold">DATA DO RESGATE</th>
                                  <th className="px-4 py-3 text-left font-semibold">MILISSEGUNDOS</th>
                                </tr>
                              </thead>

                              <tbody>
                                {(
                                  filteredRelatorio
                                ).map((item: any, index: number) => (
                                  <tr
                                    key={index}
                                    className={`${
                                      index % 2 === 0 ? "bg-white" : "bg-[#f0fbff]"
                                    } hover:bg-[#e2f6ff] transition-colors`}
                                  >
                                    <td className="text-center">{index + 1}</td>
                                    <td className="px-4 py-2 border-t border-gray-200">{item.item_name}</td>
                                    <td className="px-4 py-2 border-t border-gray-200">{item.cpf}</td>
                                    <td className="px-4 py-2 border-t border-gray-200">
                                      {moment(item.time).format("DD/MM/YYYY [às] HH:mm")}
                                    </td>
                                    <td className="px-4 py-2 border-t border-gray-200">{item.milissegundos}</td>
                                  </tr>
                                ))}
                                {filteredRelatorio.length === 0 && (
                                  <tr>
                                    <td colSpan={5} className="text-center py-4 text-gray-500">Nenhum registro encontrado</td>
                                  </tr>
                                )}
                              </tbody>
                            </table>

                          </div>
                        )}
                        
                    </div>
                  )}
                  <p className="block text-center mt-10">Informação referente até a data de hoje: {moment(new Date()).format("DD/MM/YYYY [às] HH:mm")}</p>

                </div>
                
              )}
            </div>
          </div>



        </div>
        <div className="bg-[#081c5a]">
          <RegulamentoFooter />
        </div>
      </div>
      <Outlet />
    </>
  );
}
